<template>
  <tr
    :class="[
      'text-sm',
      'hover:bg-schneider-petrol-100',
      'hover:cursor-pointer',
      { 'bg-gray-200': index % 2 === 0 },
      { 'is-damaged': isDamaged },
      { 'bg-yellow-200': isReserved && !isSold },
      { 'bg-red-200': isSold },
      { 'text-gray-500': isReserved || isSold },
    ]"
    v-on:dblclick="openJR(data['fzg_id'])"
  >
    <table-column v-bind:key="s.id" v-for="s in columns">{{
      data[s.name] ? data[s.name] + (s.suffix || "") : ""
    }}</table-column>
  </tr>
</template>

<script>
import TableColumn from "./TableColumn";

export default {
  components: { TableColumn },
  props: {
    columns: Array,
    data: Object,
    index: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    // reserviert = gelb. Langzeitreservierung (wf_blocked) wird bewusst NICHT als
    // eigener Zustand dargestellt -> langzeit-reservierte Fahrzeuge sind einfach gelb.
    isReserved() {
      return !!this.data["fzgReserviertInfo"];
    },
    isSold() {
      if (
        this.data.gebrauchtyp_fzgtool === "Gebrauchtwagen" ||
        this.data.gebrauchtyp_fzgtool === "GW"
      ) {
        return (
          !!this.data.wf_verkauft ||
          (this.data.bestandsstatus !== undefined &&
            !this.data.bestandsstatus) ||
          (this.data.eccStatus !== undefined &&
            parseInt(this.data.eccStatus) > 41)
        );
      } else if (
        this.data.gebrauchtyp &&
        this.data.gebrauchtyp !== "Gebrauchtwagen" &&
        this.data.gebrauchtyp !== "GW"
      ) {
        return !!this.data.kundenname || !!this.data.wf_verkauft;
      }
      return false;
    },
    isDamaged() {
      return !this.isSold && !this.isReserved && !!this.data.damage_ac;
    },
  },
  methods: {
    openJR(id) {
      this.$emit("openJR", id);
    },
  },
};
</script>

<style>
.is-damaged {
  background: repeating-linear-gradient(
    to right,
    #ffa20050,
    #ffa20050 10px,
    #ffffff00 10px,
    #ffffff00 20px
  );
}
</style>
